/**
 * Texty o původu recenzí (vize F2.8) — klíče kategorie Nastavení `content`
 * (Nastavení → Obsah webu) a jejich výchozí znění.
 *
 * Výchozí znění žije JEN tady v kódu: prázdný nebo chybějící klíč v Nastavení = výchozí
 * text; do Nastavení se nezapisuje (P3), obě mapy výchozích hodnot nastavení nesou `""`.
 * Znění schválil majitel 30. 9. 2026 po právní rešerši (u recenzí musí stát, zda a jak se
 * ověřují, a pravidlo výběru), proto jsou literály doslova odrážky F2.8 a mění je jen
 * majitel. Zástupné hodnoty doplňuje `fillReviewOriginText` ze souhrnu Googlu.
 */

/** Klíče v pořadí odrážek F2.8: Úvod, Od klientů, Na Googlu, Jinde na webu. */
export const REVIEW_ORIGIN_TEXT_KEYS = [
  "reviewsIntro",
  "reviewsOriginClients",
  "reviewsOriginGoogle",
  "reviewsOriginElsewhere",
] as const;

export type ReviewOriginTextKey = (typeof REVIEW_ORIGIN_TEXT_KEYS)[number];

export const REVIEW_ORIGIN_TEXT_DEFAULTS: Record<ReviewOriginTextKey, string> = {
  reviewsIntro:
    "Pětihvězdičková recenze u nás není náhoda. Garanti našich destinací v nich zpravidla žili nebo žijí a průvodci tam mají domov, většinou déle než deset let. Po návratu se klientů ptáme, jak se jim s námi cestovalo. Proto máme na Googlu hodnocení {známka} z 5 z {počet} recenzí (k {datum}).",
  reviewsOriginClients:
    "Po návratu z cesty klientům posíláme krátký dotazník. Recenze tady proto napsali jen lidé, kteří s námi opravdu cestovali. Starší recenze jsme převzali z našeho původního webu; i tam jsme zveřejňovali jen recenze klientů, kteří s námi cestovali. Zveřejňujeme všechny recenze kromě urážlivých, nepodepsaných a těch s osobními údaji.",
  reviewsOriginGoogle:
    "Pět hvězdiček má {podíl} % z {počet} recenzí na našem profilu na Googlu (k {datum}). Tady ukazujeme jen pětihvězdičkové recenze s textem, v původním znění autora. Všechny recenze, i ty s nižším hodnocením, najdete na našem profilu. Recenze z Googlu přebíráme beze změny a neověřujeme je.",
  reviewsOriginElsewhere:
    "Recenze napsali klienti, kteří s námi cestovali. Po návratu jim posíláme krátký dotazník.",
};

/** Nejdelší text o původu v Nastavení (znaky). */
export const REVIEW_ORIGIN_TEXT_MAX = 1000;

/** Zástupné hodnoty, které text smí obsahovat (nápověda v adminu, doplnění na webu). */
export const REVIEW_ORIGIN_PLACEHOLDERS = ["{známka}", "{počet}", "{podíl}", "{datum}"] as const;
